import ISkillType from "../../models/skillType";
import {
  createFeatureSelector,
  createSelector,
  createReducer,
  on,
} from "@ngrx/store";
import {
  SkillTypesApiActions,
  SkillTypesPageActions,
  EditSkillTypeActions,
  DeleteSkillTypeActions,
} from "../actions";

export interface ISkillTypesState {
  skillTypes: ISkillType[];
  isLoading: ISkillTypesLoading;
}

export interface ISkillTypesLoading {
  skillTypes: boolean;
  addSkillType: boolean;
  editSkillType: boolean;
  deleteSkillType: boolean;
}

const initialState: ISkillTypesState = {
  skillTypes: [],
  isLoading: {
    skillTypes: false,
    addSkillType: false,
    editSkillType: false,
    deleteSkillType: false,
  },
};

export const reducer = createReducer(
  initialState,
  on(SkillTypesApiActions.populateSkillTypes, (state, action) => ({
    ...state,
    skillTypes: action.skillTypes,
    isLoading: { ...state.isLoading, skillTypes: false },
  })),
  on(SkillTypesPageActions.requestAddSkillType, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, addSkillType: true },
  })),
  on(SkillTypesApiActions.skillTypeAdded, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, addSkillType: false },
  })),
  on(SkillTypesApiActions.addSkillTypeError, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, addSkillType: false },
  })),
  on(EditSkillTypeActions.requestEditSkillType, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, editSkillType: true },
  })),
  on(SkillTypesApiActions.skillTypeEdited, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, editSkillType: false },
  })),
  on(SkillTypesApiActions.editSkillTypeError, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, editSkillType: false },
  })),
  on(DeleteSkillTypeActions.requestDeleteSkillType, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, deleteSkillType: true },
  })),
  on(SkillTypesApiActions.skillTypeDeleted, (state) => ({
    ...state,
    isLoading: { ...state.isLoading, deleteSkillType: false },
  })),
);

export const getSkillTypeState =
  createFeatureSelector<ISkillTypesState>("skillTypes");
export const getSkillTypes = createSelector(
  getSkillTypeState,
  (skillTypeState) => skillTypeState.skillTypes,
);
export const getSkillTypeLoading = createSelector(
  getSkillTypeState,
  (skillTypeState) => skillTypeState.isLoading,
);
